import { render } from "./purchase-list-modal.vue?vue&type=template&id=5ad835c7"
import script from "./purchase-list-modal.vue?vue&type=script&lang=js"
export * from "./purchase-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__